/**
 * NL-026 — Tool finalize-language warning.
 *
 * Renders a small, brand-styled note adjacent to a tool's final
 * save/finalize button explaining that saving locks the tool's payload
 * and that further changes require coach access.
 *
 * Place this component **immediately above** the final submit button
 * in every `/tools/*` route. Localization keys live under
 * `tools.common.finalize.warning` in `packages/i18n/{de,en}.json`.
 */
import { useTranslation } from 'react-i18next';

interface FinalizeWarningProps {
  /** Override the default `tools.common.finalize.warning` key if a tool needs custom copy. */
  readonly i18nKey?: string;
  /** Optional className passthrough for spacing tweaks. */
  readonly className?: string;
}

export function FinalizeWarning({
  i18nKey = 'tools.common.finalize.warning',
  className,
}: FinalizeWarningProps): JSX.Element {
  const { t } = useTranslation();
  return (
    <p
      data-testid="finalize-warning"
      className={
        className ??
        'text-xs text-gray-2 mt-s2 mb-s1 px-s3 py-s2 rounded border border-bone-3 bg-bone-1'
      }
    >
      {t(i18nKey)}
    </p>
  );
}
